import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/landing/Navbar";
import FloatingActionButton from "./Components/landing/FloatingActionButton";
// import Footer from "./Components/landing/Footer";

import Home from "./Pages/Home";
import DeleteAccount from "./Pages/DeleteAccount";   // ⭐ added

import UserPrivacyPolicy from "./Pages/UserPrivacyPolicy";
import RiderPrivacyPolicy from "./Pages/RiderPrivacyPolicy";
import UserTermsAndConditions from "./Pages/UserTermsAndConditions";
import RiderTermsAndConditions from "./Pages/RiderTermsAndConditions";
import CancellationPolicy from "./Pages/CancellationPolicy";
import RefundPolicy from "./Pages/RefundPolicy";
import ShippingandDelivery from "./Pages/ShippingandDelivery";

import Services from "./Components/landing/Services";
import About from "./Components/landing/About";

import Footer from "./Components/landing/Footer";

import "./App.css";
import ContactUs from "./Components/landing/ContactUs";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<ContactUs />} />


          {/* ⭐ New delete account route */}
          <Route path="/delete-account" element={<DeleteAccount />} />

          <Route path="/user-privacy-policy" element={<UserPrivacyPolicy />} />
          <Route path="/rider-privacy-policy" element={<RiderPrivacyPolicy />} />
          <Route path="/user-terms-and-conditions" element={<UserTermsAndConditions />} />
          <Route path="/rider-terms-and-conditions" element={<RiderTermsAndConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shippinganddriving-policy" element={<ShippingandDelivery />} />
        </Routes>

        {/* <Footer /> */}
        <FloatingActionButton />
      </div>
        <Footer/>
    </Router>
  );
}

export default App;
